module.exports = __webpack_public_path__ + "assets/img/thumb-LJ-Hooker-Spring-Campaign-Video.7c4a0b43.webp";